<div class="search-bar">
  <ion-icon *ngIf="isMenuView" name="menu-outline" size="large"></ion-icon>

  <ion-input
    #input
    [clearInput]="true"
    color="primary"
    [placeholder]="placeholder"
    (ionInput)="onInput($event)"
  ></ion-input>

  <ion-icon name="search-outline" size="large"></ion-icon>
</div>
